import { render, staticRenderFns } from "./form-dropdown.vue?vue&type=template&id=81bf119a&scoped=true"
import script from "./form-dropdown.vue?vue&type=script&lang=js"
export * from "./form-dropdown.vue?vue&type=script&lang=js"
import style0 from "./form-dropdown.vue?vue&type=style&index=0&id=81bf119a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bf119a",
  null
  
)

export default component.exports